module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Semibold.182c142.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Semibold.svg
// module id = 697
// module chunks = 3